import SvgIcon from '@home/components/SvgIcon';
import TableCommonHook from '@op/components/TableCommonHook';
import ProgressColumn from '@op/pages/Overview/CompareKeyMetrics/component/ProgressColumn';
import { formatFilterDate } from '@op/utils/time';
import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { decimalFormatPercentage } from '@op/utils/value';
import { starMapNumber } from '../RatingChart';
import classnames from 'classnames';

const RatingChartTable = (props: any) => {
  const { records, filter, dataType, subtitle, eventsDict, className = '' } = props;
  const { formatMessage } = useIntl();
  const header = `${subtitle}${dataType !== 'rating' ? '%' : ''}`;

  const columns = useMemo(() => {
    const baseColumns = [
      {
        key: 'time',
        header: formatMessage({ id: 'Date' }),
        align: 'left',
        render: (cvm: any) => formatFilterDate(cvm.time, filter),
      },
      {
        key: 'name',
        header: formatMessage({ id: 'Rating-1' }),
        render: (cvm: any) => {
          const { name } = cvm;
          const getNumberStar = (num: number) => {
            const elements = [];
            for (let index = 0; index < num; index++) {
              elements.push(<SvgIcon key={index} type="star-action" />);
            }

            return elements;
          };

          return (
            <span className="star-icon">
              {getNumberStar(starMapNumber[name])}
            </span>
          );
        },
      },
      {
        key: 'value',
        header: formatMessage({ id: header }),
        render: (cvm: any) => {
          const { value } = cvm;
          return (
            <ProgressColumn
              percentage={0}
              value={value}
              oldTime={[]}
              newTime={[]}
              oldValue={''}
              hideTrend={true}
              formateValue={
                dataType === 'share' ? decimalFormatPercentage : undefined
              }
            />
          );
        },
      },
    ];

    if (dataType === 'rating') {
      baseColumns.push({
        key: 'share',
        header: formatMessage({ id: `${subtitle}%` }),
        render: (cvm: any) => {
          const { value, total } = cvm;
          return (
            <ProgressColumn
              percentage={0}
              value={value / total || 0}
              oldTime={[]}
              newTime={[]}
              oldValue={''}
              hideTrend={true}
              formateValue={decimalFormatPercentage}
            />
          );
        },
      });
    }
    return baseColumns;
  }, [dataType, filter, formatMessage, header, subtitle]);

  return (
    <>
      <TableCommonHook
        className={classnames(className)}
        recordKey={'name'}
        records={records}
        total={records.length}
        columns={columns}
        maxHeight={168.5}
        minWidth={0}
        hasPageable={false}
        {...eventsDict}
      />
    </>
  );
};

export default RatingChartTable;
